"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createApi = require("../../createApi");

var UsersApi = function (_BaseApi) {
  (0, _inherits2["default"])(UsersApi, _BaseApi);

  function UsersApi(baseUrl) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      baseUrl: baseUrl
    };
    var olyEngineApi = arguments.length > 2 ? arguments[2] : undefined;
    var searchService = arguments.length > 3 ? arguments[3] : undefined;
    (0, _classCallCheck2["default"])(this, UsersApi);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(UsersApi).call(this, baseUrl, options, olyEngineApi));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "searchService", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getUsers", function (_ref) {
      var search = _ref.search,
          _ref$skip = _ref.skip,
          skip = _ref$skip === void 0 ? 0 : _ref$skip,
          _ref$limit = _ref.limit,
          limit = _ref$limit === void 0 ? 20 : _ref$limit,
          contextIds = _ref.contextIds;
      return _this.api.get('/users', {
        params: {
          search: search,
          skip: skip,
          limit: limit,
          contextIds: contextIds
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getUsersByQuery", function (_ref2) {
      var index = _ref2.index,
          query = _ref2.query,
          searchOptions = _ref2.searchOptions;
      return _this.searchService.requestIndex({
        index: index,
        query: query,
        searchOptions: searchOptions
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getUser", function (_ref3) {
      var id = _ref3.id,
          clientId = _ref3.clientId,
          withGroup = _ref3.withGroup;
      return _this.api.get("/users/".concat(id), {
        params: {
          clientId: clientId,
          withGroup: withGroup
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getUserClients", function (_ref4) {
      var id = _ref4.id,
          clientId = _ref4.clientId;
      return _this.api.get("/users/".concat(id, "/clients"), {
        params: {
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getOneUserClient", function (_ref5) {
      var id = _ref5.id,
          clientId = _ref5.clientId;
      return _this.api.get("/users/".concat(id, "/clients/").concat(clientId));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "editUserSettings", function (_ref6) {
      var id = _ref6.id,
          clientId = _ref6.clientId,
          settings = _ref6.settings;
      return _this.api.put("/users/".concat(id, "/clients/").concat(clientId, "/settings"), {
        data: {
          settings: settings
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "editUserClient", function (_ref7) {
      var id = _ref7.id,
          clientId = _ref7.clientId,
          settings = _ref7.settings,
          metadata = _ref7.metadata;
      return _this.api.put("/users/".concat(id, "/clients/").concat(clientId), {
        data: {
          settings: settings,
          metadata: metadata
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "editUserProfile", function (_ref8) {
      var id = _ref8.id,
          clientId = _ref8.clientId,
          profile = _ref8.profile;
      return _this.api.put("/users/".concat(id, "?clientId=").concat(clientId), {
        data: profile
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "editUserTimezone", function (_ref9) {
      var id = _ref9.id,
          timezone = _ref9.timezone,
          token = _ref9.token;
      return _this.api.put("/users/".concat(id), {
        data: {
          'locations.timezone': timezone
        },
        headers: token ? {
          Authorization: token
        } : {}
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "editUserClientEmail", function (_ref10) {
      var id = _ref10.id,
          clientId = _ref10.clientId,
          emailData = _ref10.emailData,
          token = _ref10.token,
          newsletter = _ref10.newsletter;
      return _this.api.put("/users/".concat(id, "/clients/").concat(clientId, "/newsletter?token=").concat(token), {
        data: {
          email: emailData,
          newsletter: newsletter
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "editUserGroupRank", function (_ref11) {
      var rank = _ref11.rank,
          groupId = _ref11.groupId,
          userId = _ref11.userId;
      return _this.api.put("/users/".concat(userId, "/groups/").concat(groupId, "/rank"), {
        data: {
          rank: rank
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "editUsersGroupRank", function (_ref12) {
      var clientId = _ref12.clientId,
          groupId = _ref12.groupId,
          userIds = _ref12.userIds,
          rank = _ref12.rank;
      return _this.api.put("/users/groups/rank", {
        data: {
          clientId: clientId,
          groupId: groupId,
          userIds: userIds,
          rank: rank
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getTokenFromSsoToken", function (_ref13) {
      var clientId = _ref13.clientId,
          ssoToken = _ref13.ssoToken,
          language = _ref13.language,
          token = _ref13.token,
          _ref13$withState = _ref13.withState,
          withState = _ref13$withState === void 0 ? true : _ref13$withState,
          referralId = _ref13.referralId;
      return _this.api.get('/auth/sso', {
        headers: token ? {
          Authorization: token
        } : {},
        params: {
          clientId: clientId,
          idToken: ssoToken,
          language: language,
          withState: withState,
          referralId: referralId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getDataFromSsoToken", function (_ref14) {
      var idToken = _ref14.idToken,
          clientId = _ref14.clientId;
      return _this.api.get('/auth/sso/token', {
        params: {
          idToken: idToken,
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getDataFromToken", function (_ref15) {
      var token = _ref15.token,
          clientId = _ref15.clientId;
      return _this.api.post('/auth/token', {
        data: {
          token: token,
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "login", function (_ref16) {
      var email = _ref16.email,
          password = _ref16.password,
          client = _ref16.client,
          clientId = _ref16.clientId,
          token = _ref16.token,
          withState = _ref16.withState;
      return _this.api.post('/auth/login', {
        withoutAuth: true,
        params: {
          clientId: clientId,
          withState: withState
        },
        data: {
          email: email,
          password: password,
          client: client,
          token: token
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "signup", function (_ref17) {
      var clientId = _ref17.clientId,
          email = _ref17.email,
          firstName = _ref17.firstName,
          lastName = _ref17.lastName,
          password = _ref17.password,
          client = _ref17.client,
          timezone = _ref17.timezone,
          referralId = _ref17.referralId,
          withState = _ref17.withState;
      return _this.api.post('/auth/signup', {
        withoutAuth: true,
        params: {
          clientId: clientId
        },
        data: {
          client: client,
          email: email,
          firstName: firstName,
          lastName: lastName,
          password: password,
          timezone: timezone,
          referralId: referralId,
          withState: withState
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "signupClient", function (_ref18) {
      var clientId = _ref18.clientId,
          token = _ref18.token,
          client = _ref18.client,
          withState = _ref18.withState,
          referralId = _ref18.referralId;
      return _this.api.post('/auth/signup/client', {
        params: {
          clientId: clientId,
          token: token,
          withState: withState,
          referralId: referralId
        },
        data: {
          client: client
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getStreamAppToken", function (_ref19) {
      var id = _ref19.id;
      return _this.api.get("/users/".concat(id, "/token/stream"));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "deleteUser", function (userId) {
      return _this.api["delete"]("/users/".concat(userId));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "deleteUserClient", function (_ref20) {
      var userId = _ref20.userId,
          clientId = _ref20.clientId;
      return _this.api["delete"]("/users/".concat(userId, "/clients/").concat(clientId));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "deleteUserGroup", function (_ref21) {
      var userId = _ref21.userId,
          groupId = _ref21.groupId,
          clientId = _ref21.clientId;
      return _this.api["delete"]("/users/".concat(userId, "/groups/").concat(groupId), {
        params: {
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "deleteUsersGroup", function (_ref22) {
      var files = _ref22.files,
          clientId = _ref22.clientId,
          groupId = _ref22.groupId,
          userIds = _ref22.userIds;
      return _this.api.post("/users/groups/delete", {
        data: {
          userIds: userIds
        },
        params: {
          clientId: clientId,
          groupId: groupId,
          files: files
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getRoles", function (_ref23) {
      var _ref23$search = _ref23.search,
          search = _ref23$search === void 0 ? null : _ref23$search,
          _ref23$skip = _ref23.skip,
          skip = _ref23$skip === void 0 ? 0 : _ref23$skip,
          _ref23$limit = _ref23.limit,
          limit = _ref23$limit === void 0 ? 20 : _ref23$limit;
      return _this.api.get('/roles', {
        params: {
          search: search,
          skip: skip,
          limit: limit
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getUserRoles", function (_ref24) {
      var userId = _ref24.userId,
          _ref24$clientId = _ref24.clientId,
          clientId = _ref24$clientId === void 0 ? null : _ref24$clientId,
          _ref24$contextId = _ref24.contextId,
          contextId = _ref24$contextId === void 0 ? null : _ref24$contextId;
      return _this.api.get("/users/".concat(userId, "/roles"), {
        params: {
          clientId: clientId,
          contextId: contextId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getUserAvailableClients", function (_ref25) {
      var email = _ref25.email;
      return _this.api.get("/users/clients", {
        params: {
          email: email
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "createRole", function (_ref26) {
      var payload = (0, _extends2["default"])({}, _ref26);
      return _this.api.post("/users/".concat(payload.userId, "/roles"), {
        data: payload
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateRole", function (_ref27) {
      var payload = (0, _extends2["default"])({}, _ref27);
      return _this.api.put("/users/".concat(payload.userId, "/roles/").concat(payload.roleId), {
        data: payload
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "deleteRole", function (_ref28) {
      var userId = _ref28.userId,
          roleId = _ref28.roleId,
          _ref28$clientId = _ref28.clientId,
          clientId = _ref28$clientId === void 0 ? null : _ref28$clientId;
      return _this.api["delete"]("/users/".concat(userId, "/roles/").concat(roleId), {
        params: {
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "refreshAccessToken", function (payload) {
      return _this.api.post('/auth/token/refresh', {
        data: payload
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getTokenState", function (payload) {
      return _this.api.post('/auth/token/state', {
        data: payload,
        headers: {
          withoutAuth: true
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getTokenStateFromOldToken", function (_ref29) {
      var oldToken = _ref29.oldToken,
          clientId = _ref29.clientId;
      return _this.api.get("/auth/token", {
        headers: {
          Authorization: oldToken
        },
        params: {
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateUser", function (_ref30) {
      var id = _ref30.id,
          data = _ref30.data,
          clientId = _ref30.clientId;
      return _this.api.put("/users/".concat(id), {
        params: {
          clientId: clientId
        },
        data: data
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setUserTypology", function (_ref31) {
      var id = _ref31.id,
          data = _ref31.data,
          clientId = _ref31.clientId;
      return _this.api.post("/users/".concat(id, "/typology"), {
        params: {
          clientId: clientId
        },
        data: data
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getUserTypology", function (_ref32) {
      var id = _ref32.id,
          clientId = _ref32.clientId;
      return _this.api.get("/users/".concat(id, "/typology"), {
        params: {
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateUserTypology", function (_ref33) {
      var id = _ref33.id,
          typologyId = _ref33.typologyId,
          data = _ref33.data,
          clientId = _ref33.clientId;
      return _this.api.put("/users/".concat(id, "/typology/").concat(typologyId), {
        params: {
          clientId: clientId
        },
        data: data
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setUserMotivations", function (_ref34) {
      var id = _ref34.id,
          data = _ref34.data,
          clientId = _ref34.clientId;
      return _this.api.post("/users/".concat(id, "/motivations"), {
        params: {
          clientId: clientId
        },
        data: data
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getUserMotivations", function (_ref35) {
      var id = _ref35.id,
          clientId = _ref35.clientId;
      return _this.api.get("/users/".concat(id, "/motivations"), {
        params: {
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getUserReferrals", function (_ref36) {
      var clientId = _ref36.clientId,
          userId = _ref36.userId,
          _ref36$skip = _ref36.skip,
          skip = _ref36$skip === void 0 ? 0 : _ref36$skip,
          _ref36$limit = _ref36.limit,
          limit = _ref36$limit === void 0 ? 20 : _ref36$limit;
      return _this.api.get("/users/".concat(userId, "/clients/").concat(clientId, "/sponsored"), {
        params: {
          skip: skip,
          limit: limit
        }
      });
    });
    _this.searchService = searchService;
    return _this;
  }

  return UsersApi;
}(_createApi.BaseApi);

var _default = UsersApi;
exports["default"] = _default;
//# sourceMappingURL=index.js.map